var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcnRendicontazioni = function SvgIcnRendicontazioni(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.965,
    height: 17.572,
    viewBox: "0 0 21.965 17.572",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(-16 -64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(16 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M36.5,77.179H17.464A1.466,1.466,0,0,1,16,75.714V65.464A1.466,1.466,0,0,1,17.464,64H36.5a1.466,1.466,0,0,1,1.464,1.464v10.25A1.466,1.466,0,0,1,36.5,77.179ZM17.464,65.464v10.25H36.5V65.464Z",
    transform: "translate(-16 -64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(17.464 77.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M66.3,369.464H48.732a.732.732,0,1,1,0-1.464H66.3a.732.732,0,1,1,0,1.464Z",
    transform: "translate(-48 -368)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(18.929 80.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M95.375,417.464H80.732a.732.732,0,0,1,0-1.464H95.375a.732.732,0,1,1,0,1.464Z",
    transform: "translate(-80 -416)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(22.589 66.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M164.393,120.786a4.393,4.393,0,1,1,4.393-4.393A4.4,4.4,0,0,1,164.393,120.786Zm0-7.322a2.929,2.929,0,1,0,2.929,2.929A2.932,2.932,0,0,0,164.393,113.464Z",
    transform: "translate(-160 -112)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(32.84 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M388.393,69.125A4.4,4.4,0,0,1,384,64.732a.732.732,0,0,1,1.464,0,2.932,2.932,0,0,0,2.929,2.929.732.732,0,1,1,0,1.464Z",
    transform: "translate(-384 -64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(16 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M16.732,69.125a.732.732,0,1,1,0-1.464,2.932,2.932,0,0,0,2.929-2.929.732.732,0,1,1,1.464,0A4.4,4.4,0,0,1,16.732,69.125Z",
    transform: "translate(-16 -64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(32.84 72.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M384.732,245.125a.732.732,0,0,1-.732-.732A4.4,4.4,0,0,1,388.393,240a.732.732,0,1,1,0,1.464,2.932,2.932,0,0,0-2.929,2.929A.732.732,0,0,1,384.732,245.125Z",
    transform: "translate(-384 -240)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(16 72.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M20.393,245.125a.732.732,0,0,1-.732-.732,2.932,2.932,0,0,0-2.929-2.929.732.732,0,0,1,0-1.464,4.4,4.4,0,0,1,4.393,4.393A.732.732,0,0,1,20.393,245.125Z",
    transform: "translate(-16 -240)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnRendicontazioni, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_rendicontazioni.e1bc7917.svg";
export { ForwardRef as ReactComponent };